import React from 'react'
import { IResourceStatus } from '../types/operations.types'
import {
  OpsCard,
  OpsCardHeader,
  ResourceGrid,
  ResourceItem,
  opsColors,
} from '../styled/Operations.styled'

interface ResourceStatusPanelProps {
  data: IResourceStatus
}

export const ResourceStatusPanel: React.FC<ResourceStatusPanelProps> = ({ data }) => {
  return (
    <OpsCard>
      <OpsCardHeader>
        <h3>Resources</h3>
      </OpsCardHeader>

      <div style={{ marginBottom: '1rem' }}>
        <div style={{ fontSize: '10px', fontWeight: 500, textTransform: 'uppercase', color: opsColors.textFaded, marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
          Workforce
        </div>
        <ResourceGrid>
          <ResourceItem>
            <span className="resource-label">Available</span>
            <span className="resource-count" style={{ color: opsColors.textFaded }}>{data.workforce.available}</span>
          </ResourceItem>
          <ResourceItem>
            <span className="resource-label">Assigned</span>
            <span className="resource-count" style={{ color: opsColors.successBase }}>{data.workforce.assigned}</span>
          </ResourceItem>
          <ResourceItem>
            <span className="resource-label">On Break</span>
            <span className="resource-count" style={{ color: opsColors.warningBase }}>{data.workforce.onBreak}</span>
          </ResourceItem>
          <ResourceItem>
            <span className="resource-label">Unavailable</span>
            <span className="resource-count" style={{ color: opsColors.dangerBase }}>{data.workforce.unavailable}</span>
          </ResourceItem>
        </ResourceGrid>
      </div>

      <div>
        <div style={{ fontSize: '10px', fontWeight: 500, textTransform: 'uppercase', color: opsColors.textFaded, marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
          Machines
        </div>
        <ResourceGrid>
          <ResourceItem>
            <span className="resource-label">Active</span>
            <span className="resource-count" style={{ color: opsColors.successBase }}>{data.machines.active}</span>
          </ResourceItem>
          <ResourceItem>
            <span className="resource-label">Idle</span>
            <span className="resource-count" style={{ color: opsColors.warningBase }}>{data.machines.idle}</span>
          </ResourceItem>
          <ResourceItem>
            <span className="resource-label">Maintenance</span>
            <span className="resource-count" style={{ color: opsColors.infoBase }}>{data.machines.maintenance}</span>
          </ResourceItem>
          <ResourceItem>
            <span className="resource-label">Offline</span>
            <span className="resource-count" style={{ color: opsColors.dangerBase }}>{data.machines.offline}</span>
          </ResourceItem>
        </ResourceGrid>
      </div>
    </OpsCard>
  )
}
